export default __webpack_public_path__ + "static/media/delete.df278b59.svg";